export default __webpack_public_path__ + "static/media/basket.5e6dba09.png";